<template>
  <div id="app">
    <NavBar />
    <div id="fullpage">
      <div class="section">
        <Section1 :is-active="currentIndex === 0" />
      </div>
      <div class="section">
        <Section2 :is-active="currentIndex === 1" />
      </div>
      <div class="section">
        <Section3 :is-active="currentIndex === 2" />
      </div>
      <div class="section">
        <Section4 :is-active="currentIndex === 3||currentIndex === 4" />
      </div>
      <div class="section fp-auto-height">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import 'fullpage.js/dist/fullpage.min.css'
import fullpage from 'fullpage.js'
import NavBar from './components/NavBar.vue'
import Section1 from './components/Section1.vue'
import Section2 from './components/Section2.vue'
import Section3 from './components/Section3.vue'
import Section4 from './components/Section4.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Section1,
    Section2,
    Section3,
    Section4,
    Footer
  },
  data() {
    return {
      currentIndex: 0
    }
  },
  mounted() {
    this.fullpageInstance = new fullpage('#fullpage', {
      navigation: true,
      navigationPosition: 'right',
      scrollingSpeed: 600,
      afterLoad: (origin, destination) => {
        this.currentIndex = destination.index;
      },
      normalScrollElements: '.footer',
      css3: true,
      fitToSection: true,
      scrollBar: false,
    });
  },
  beforeDestroy() {
    if (this.fullpageInstance) {
      this.fullpageInstance.destroy('all');
    }
  }
}
</script>

<style lang="css">
@import "~animate.css";

html, body {
  margin: 0;
  padding: 0;
}

#app {
  height: 100vh;
  background: #000;
}

#fullpage {
  height: 100vh;
}

.section {
  height: 100vh;
}

.fp-section {
  height: 100vh;
  position: relative;
  touch-action: none;
  width: 100%;
}

/* 自定义导航样式 */
#fp-nav ul li a span {
  background: #42b983;
}

#fp-nav ul li a.active span {
  background: #fff;
}

/* 隐藏水印 */
#fp-watermark,
.fp-watermark,
div[style*="fullPage.js"] {
  display: none !important;
}

/* 响应式样式 */
@media screen and (max-width: 768px) {
  .section {
    height: auto;
    min-height: auto;
  }

  .fp-section {
    height: auto;
    min-height: auto;
  }

  #fp-nav {
    display: none;
  }

  #fullpage {
    height: auto;
  }

  .section.fp-auto-height {
    height: auto;
    min-height: auto;
  }
}
</style>
